import { render, staticRenderFns } from "./consumables.vue?vue&type=template&id=7599c39e&scoped=true&"
import script from "./consumables.vue?vue&type=script&lang=js&"
export * from "./consumables.vue?vue&type=script&lang=js&"
import style0 from "./consumables.vue?vue&type=style&index=0&id=7599c39e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7599c39e",
  null
  
)

export default component.exports